export default __webpack_public_path__ + "static/media/5.af1c7514.png";